import React, { useEffect } from "react";
import ReportTab from "./ReportTab";
import ReportDetails from "./ReportDetails";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";

const Extraversion = (props: any) => {
    const scoreDescription = {
        High: ["Energetic", "Outgoing", "Friendly", "Action-Oriented", "Risk-Taker"],
        Moderate: ["Comfortable in most environments", "Works well both solo and on a team", "Good communication skills", "Indecisive", "Trusting"],
        Low: ["Quiet", "Private", "Reserved", "Task-Oriented", "Calm"],
    };
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id={"title-page-" + props.name} tabIndex={-1}>
                        RepIQ™ Reputation Analyzer Report
                    </h1>
                </div>
            </div>

            <ReportTab selectedTab="5" />

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Extraversion</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <p>
                                        Extraversion measures the degree to which someone is energized by socializing and interacting with others. People who score
                                        high in Extraversion are often seen as positive, fun-loving, and outgoing. They are comfortable in groups, initiating
                                        conversations, and meeting new friends. High Extraversion is a common trait seen amongst entrepreneurs.
                                    </p>
                                    <p>
                                        People who score low in Extraversion (or high in Introversion) are energized by their internal world and find active social
                                        settings overwhelming. They tend to be reserved, thoughtful in their word choice, and hesitant to initiate conversations.
                                    </p>
                                </div>
                                <div className="col-xs-12 col-sm-3">
                                    <div role="option" className="img-container">
                                        <img src="images/img-extraversion.jpg" alt="Extroverts talking and being the center of atention" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReportDetails title={"Extraversion"} name={"Extraversion"} scoreDescription={scoreDescription} />
                </div>
            </div>
        </React.Fragment>
    );
};
export default Extraversion;
